import React, { Component } from "react";
import $ from "jquery";
import Select from "react-select";
import PdfViewer from "./PdfViewer";
import PartnerCreateModal from "./PartnerCreateModal";

const selectStyles = {
    container: (base) => ({ ...base, flex: 1 }),
    control: (base) => ({
        ...base,
        height: 38,
        minHeight: 38,
        borderRadius: 4,
        backgroundColor: "transparent",
        borderColor: "#ced4da",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
    singleValue: (base) => ({ ...base, color: "#000" }),
};

class ReportEstatusFacturasModal extends Component {

    componentDidMount() {
        this.closeAction();
        this.applyFixedFilters();
    }

    applyFixedFilters = () => {
        const { SetFixedFilters } = this.props;
        const access = this.getAccessLevel();

        const sucursalToSet = !access.canSeeAllSucursales ? access.fixedSucursal : null;
        const usuarioToSet = !access.canSeeAllUsuarios ? access.fixedUsuario : null;

        if (sucursalToSet != null || usuarioToSet != null) {
            SetFixedFilters(sucursalToSet, usuarioToSet);
        }
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $("#reportEstatusFacturasModal").on("hidden.bs.modal", function () {
            cleanData();
            setTimeout(() => {
                if ($('.modal:visible').length === 0 && $('.modal-backdrop').length > 0) {
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open').css('padding-right', '');
                }
            }, 350);
        });
    };

    getAccessLevel = () => {
        const { _user } = this.props;
        const role = (_user?.U_FMB_role || _user?.FMB_Role || '').toLowerCase();
        const counterRol = (_user?.U_FMB_CounterRol || '').toLowerCase();

        if (role.startsWith('admin')) {
            return {
                level: 'ADMIN',
                canSeeAllSucursales: true,
                canSeeAllUsuarios: true,
                fixedSucursal: null,
                fixedUsuario: null,
            };
        }

        if (role.startsWith('branch')) {
            return {
                level: 'BRANCH',
                canSeeAllSucursales: false,
                canSeeAllUsuarios: false,
                fixedSucursal: _user?.U_FMB_Sucursal ?? null,
                fixedUsuario: _user?.USER_CODE ?? null,
            };
        }

        if (role.startsWith('counter')) {
            const isGerente = counterRol === 'manager';
            return {
                level: isGerente ? 'COUNTER_GERENTE' : 'COUNTER_BASICO',
                canSeeAllSucursales: false,
                canSeeAllUsuarios: isGerente,
                fixedSucursal: _user?.U_FMB_Sucursal ?? null,
                fixedUsuario: isGerente ? null : (_user?.USER_CODE ?? null),
            };
        }

        return {
            level: 'DESCONOCIDO',
            canSeeAllSucursales: false,
            canSeeAllUsuarios: false,
            fixedSucursal: _user?.U_FMB_Sucursal ?? null,
            fixedUsuario: _user?.USER_CODE ?? null,
        };
    };

    findOption = (options, value) =>
        options.find(opt => String(opt.value) === String(value)) || options[0] || null;

    buildSelectEvent = (value, label = '') => {
        const target = {
            value,
            selectedIndex: 0,
            options: [{ textContent: label, value }],
        };
        return { target, nativeEvent: { target } };
    };

    render() {
        const {
            ReportsModel,
            ChangeClient,
            ActualDate,
            ChangeInitialDate,
            ChangeFinalDate,
            ChangeUser,
            ChangeType,
            ChangeStatus,
            ChangePayStatus,
            ChangeDocType,
            ListUsers,
            GenerateReport,
            ListReports,
            ShowPDFViewerModal,
            ShowPDFViewer,
            OpenPartnerModal,
            partners,
            pageTotal,
            SelectPartner,
            cleanDataPartners,
            RefreshPartner,
            MailTools,
            sucursales,
            ChangeSucursal,
            printhide,
            ShowFormatToPrint,
        } = this.props;

        const access = this.getAccessLevel();

        const sucursalOptions = [
            { value: '---', label: 'Todas' },
            ...(sucursales || []).map(s => ({ value: s.pk_Sucursal, label: s.nombre })),
        ];

        const userOptions = [
            { value: '---', label: 'Todos' },
            ...(ListUsers || []).map(u => ({ value: u.USER_CODE, label: `${u.U_NAME}` })),
        ];

        const typeOptions = [
            { value: '---', label: 'Todas' },
            { value: 'contado', label: 'Contado' },
            { value: 'credito', label: 'Crédito' },
        ];

        const docTypeOptions = [
            { value: '---', label: 'Todos' },
            { value: 'FACTURA', label: 'Factura' },
            { value: 'CESION', label: 'Cesión en uso' },
            { value: 'GASTO', label: 'Gasto administrativo' },
        ];

        const statusOptions = [
            { value: '---', label: 'Todos' },
            { value: 'O', label: 'Abierta' },
            { value: 'C', label: 'Cerrada' },
            { value: 'CANCELLED', label: 'Cancelada' },
        ];

        const payStatusOptions = [
            { value: '---', label: 'Todos' },
            { value: 'PAGADA', label: 'Pagada' },
            { value: 'PARCIAL', label: 'Pago parcial' },
            { value: 'PENDIENTE', label: 'Pendiente' },
        ];

        return (
            <div className="modal fade" id="reportEstatusFacturasModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="reportEstatusFacturasModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Estatus de Facturas</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2">
                                <div className="row">
                                    {access.level === 'ADMIN' &&
                                        <div className="col-12 col-md-6 col-lg-4">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <label className="input-group-text font-weight-bold"> Cliente </label>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Codigo"
                                                    value={ReportsModel.CardCode}
                                                    onChange={(event) => ChangeClient(event)}
                                                    onKeyDown={({ key }) => { if (key === "Enter") { OpenPartnerModal() } }} />
                                                <div className="input-group-prepend">
                                                    <button
                                                        className="btn btn-outline-dark rounded-right"
                                                        onClick={OpenPartnerModal}>
                                                        <i className="fa fa-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="col-12 col-lg-4">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Desde </strong></span>
                                            </div>
                                            <input
                                                type="date" className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.InitialDate}
                                                onChange={(event) => ChangeInitialDate(event)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Hasta </strong></span>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.FinalDate}
                                                onChange={(event) => ChangeFinalDate(event)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Sucursal</strong></span>
                                            </div>
                                            {access.canSeeAllSucursales ? (
                                                <Select
                                                    options={sucursalOptions}
                                                    value={this.findOption(sucursalOptions, ReportsModel.Sucursal)}
                                                    onChange={(opt) => ChangeSucursal(this.buildSelectEvent(opt ? opt.value : '---', opt ? opt.label : 'Todas'), true)}
                                                    placeholder="Buscar sucursal..."
                                                    isSearchable={true}
                                                    isClearable={false}
                                                    menuPortalTarget={document.body}
                                                    noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                    styles={selectStyles}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={
                                                        (sucursales || []).find(s => s.pk_Sucursal === access.fixedSucursal)?.nombre
                                                        || this.props._user?.Sucursal
                                                        || 'Mi sucursal'
                                                    }
                                                    disabled
                                                    readOnly
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Usuario/Vendedor</strong></span>
                                            </div>
                                            {access.canSeeAllUsuarios ? (
                                                <Select
                                                    options={userOptions}
                                                    value={this.findOption(userOptions, ReportsModel.User)}
                                                    onChange={(opt) => ChangeUser(this.buildSelectEvent(opt ? opt.value : '---', opt ? opt.label : 'Todos'))}
                                                    placeholder="Buscar usuario..."
                                                    isSearchable={true}
                                                    isClearable={false}
                                                    menuPortalTarget={document.body}
                                                    noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                    styles={selectStyles}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this.props._user?.U_NAME || access.fixedUsuario || 'Yo'}
                                                    disabled
                                                    readOnly
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Condición</strong></span>
                                            </div>
                                            <Select
                                                options={typeOptions}
                                                value={this.findOption(typeOptions, ReportsModel.Type)}
                                                onChange={(opt) => ChangeType(this.buildSelectEvent(opt ? opt.value : '---', opt ? opt.label : 'Todas'))}
                                                placeholder="Buscar condición..."
                                                isSearchable={true}
                                                isClearable={false}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                styles={selectStyles}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Tipo de documento</strong></span>
                                            </div>
                                            <Select
                                                options={docTypeOptions}
                                                value={this.findOption(docTypeOptions, ReportsModel.DocType)}
                                                onChange={(opt) => ChangeDocType(this.buildSelectEvent(opt ? opt.value : '---', opt ? opt.label : 'Todos'))}
                                                placeholder="Buscar tipo..."
                                                isSearchable={true}
                                                isClearable={false}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                styles={selectStyles}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Estatus de factura</strong></span>
                                            </div>
                                            <Select
                                                options={statusOptions}
                                                value={this.findOption(statusOptions, ReportsModel.Status)}
                                                onChange={(opt) => ChangeStatus(this.buildSelectEvent(opt ? opt.value : '---', opt ? opt.label : 'Todos'))}
                                                placeholder="Buscar estatus..."
                                                isSearchable={true}
                                                isClearable={false}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                styles={selectStyles}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Estatus de cobranza</strong></span>
                                            </div>
                                            <Select
                                                options={payStatusOptions}
                                                value={this.findOption(payStatusOptions, ReportsModel.PayStatus)}
                                                onChange={(opt) => ChangePayStatus(this.buildSelectEvent(opt ? opt.value : '---', opt ? opt.label : 'Todos'))}
                                                placeholder="Buscar estatus..."
                                                isSearchable={true}
                                                isClearable={false}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                styles={selectStyles}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" >Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => GenerateReport()}>Generar</button>
                        </div>
                    </div>
                </div>

                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        TypeDoc={"Report_EstatusFacturas"}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={"SalesTools.EditableDocModel"}
                        RefreshDocModel={"SalesTools.RefreshDocModel"}
                        SaveChanges={"SalesTools.SaveChangesOrderInvoice"}
                        UploadDoc={"SalesTools.UploadInvoice"}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={"user"}
                        Counter={true}
                        MailTools={MailTools}
                        ReportsModel={ReportsModel}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false}
                    />
                }

                {partners.length > 0 &&
                    <PartnerCreateModal
                        data={partners}
                        type={"C"}
                        totalPage={pageTotal}
                        selectPartner={SelectPartner}
                        cleanData={cleanDataPartners}
                        refreshPartner={RefreshPartner}
                    />
                }
            </div>
        );
    }
}

export default ReportEstatusFacturasModal;